type statisticType = {
  title: string;
  value: number;
};

type responseQuestionType = {
  name: string;
  id: string;
};

export const statistics: statisticType[] = [
  {
    title: "عدد العطاءات",
    value: 100,
  },
  {
    title: "عدد العملاء",
    value: 100,
  },
  {
    title: "عدد العملاء",
    value: 100,
  },
  {
    title: "عدد العملاء",
    value: 100,
  },
];

/************************Navbar items********************************/
// Define the type
export interface SubItem {
  name: string;
  link: string;
}
interface Section {
  id: string;
  label: string;
  link: string;
  subList: SubItem[];
}
export const sections: Section[] = [
  {
    id: "about",
    label: "sections.about.label",
    link: "",
    subList: [
      {
        name: "sections.about.subList.ourStory",
        link: "/our-story",
      },
      {
        name: "sections.about.subList.objectives",
        link: "/objectives",
      },
      // {
      //   name: "sections.branches.label",
      //   link: "/our-branches",
      //  },
      {
        name: "footer.content.point2",
        link: "/",
      },
      {
        name: "sections.about.subList.visionMission",
        link: "/vision-mission",
      },
      {
        name: "footer.content.point3",
        link: "/organizational-structure",
      },
      //{
      //  name: "sections.about.subList.administrativeStructure",
      //  link: "/administrative-structure",
      //  },
      // {
      //  name: "sections.about.subList.developmentQuality",
      //  link: "/quality-development",
      // },
      //  {
      //   name: "sections.about.subList.performanceReports",
      //  link: "/performance-reports",
      //},
      {
        name: "sections.about.subList.certificatesAwards",
        link: "/our-certificates-awards",
      },
      {
        name: "sections.about.subList.permitsAssociation",
        link: "/permits-association",
      },
    ],
  },

  {
    id: "governance",
    label: "sections.governance.label",
    link: "",
    subList: [
      {
        name: "sections.governance.subList.regulationsAndSystem",
        link: "/regulations",
      },
      {
        name: "sections.governance.subList.officials",
        link: "/officials",
      },
      {
        name: "sections.governance.subList.associationData",
        link: "/association-data",
      },
      {
        name: "sections.governance.subList.goalsPrograms",
        link: "/goals-programs",
      },
      {
        name: "sections.governance.subList.financialStatement",
        link: "/financial-statement",
      },
      /*
      {
        name: "sections.governance.subList.dsisclosureTransparency",
        link: "/disclosure-transparency",
      },

      {
        name: "sections.governance.subList.operationalPlan",
        link: "/operational-plans",
      },
      {
        name: "sections.about.subList.developmentQuality",
        link: "/quality-development",
      },
      {
        name: "sections.about.subList.performanceReports",
        link: "/performance-reports",
      },

      //{
      //  name: "sections.governance.subList.food",
      //  link: "/feedback",
      // },*/
    ],
  },
  {
    id: "projects",
    label: "sections.projects.label",
    link: "",
    subList: [
      {
        name: "sections.projects.subList.seasonalProjects",
        link: "/seasonal-projects",
      },
      {
        name: "sections.projects.subList.generalProjects",
        link: "/general-projects",
      },
      {
        name: "sections.projects.subList.branchProjects",
        link: "/branch-projects",
      },
    ],
  },
  {
    id: "donationMethods",
    label: "sections.about.subList.bankAccounts",
    link: "/donation-methods",
    subList: [],
  },
  {
    id: "programs",
    label: "footer.content.point12",
    link: "",
    subList: [
      {
        name: "sections.beneficiaries.subList.programsActivities",
        link: "/programs",
      },
      {
        name: "sections.beneficiaries.subList.training",
        link: "/training",
      },
      {
        name: "sections.beneficiaries.subList.initiatives",
        link: "/initiatives",
      },
    ],
  },
  {
    id: "beneficiaries",
    label: "sections.beneficiaries.label",
    link: "",
    subList: [
      //   {
      //   name: "sections.beneficiaries.subList.beneficiaryPortal",
      //   link: "/login",
      //   },
      {
        name: "sections.beneficiaries.subList.sponsorsPortal",
        link: "/login",
      },
      {
        name: "sections.beneficiaries.subList.usersPortal",
        link: "https://erp.takaful.sa/",
      },
      {
        name: "sections.beneficiaries.subList.addBeneficiary",
        link: "/beneficiary/add",
      },
      {
        name: "sections.beneficiaries.subList.addSponsor",
        link: "/add-sponsor",
      },

      // {
      //  name: "sections.beneficiaries.subList.memberships",
      //    link: "",
      //  },
      {
        name: "sections.beneficiaries.subList.programs",
        link: "/programs",
      },
    ],
  },
  {
    id: "partnerships",
    label: "sections.partnerships.label",
    link: "",
    subList: [
      {
        name: "sections.partnerships.subList.addPartnership",
        link: "/add-partnership",
      },
      {
        name: "sections.partnerships.subList.partnersList",
        link: "/partners",
      },
    ],
  },

  {
    id: "mediaCenter",
    label: "sections.mediaCenter.label",
    link: "",
    subList: [
      {
        name: "sections.mediaCenter.subList.news",
        link: "/news",
      },
      {
        name: "sections.mediaCenter.subList.photoAlbum",
        link: "/our-photo",
      },
      {
        name: "sections.mediaCenter.subList.videos",
        link: "/our-video",
      },
      { name: "sections.about.subList.annualReports", link: "/annual-reports" },
      {
        name: "sections.evaluation.label",
        link: "/evaluation",
      },
    ],
  },
  {
    id: "joinUs",
    label: "sections.joinUs.label",
    link: "",
    subList: [
      {
        name: "sections.beneficiaries.subList.volunteerNow",
        link: "https://nvg.gov.sa/",
      },
      {
        name: "sections.contact.subList.employment",
        link: "/jobs",
      },
    ],
  },
  {
    id: "contact",
    label: "sections.contact.label",
    link: "",
    subList: [
      {
        name: "sections.contact.subList.suggestionsComplaints",
        link: "/suggestions-complaints",
      },
      {
        name: "sections.contact.subList.contactUs",
        link: "/contact-us",
      },
    ],
  },
];

export const reponseQuestion: responseQuestionType[] = [
  {
    name: "لا",
    id: "no",
  },
  {
    name: "نعم",
    id: "yes",
  },
  {
    name: "نوعاً ما",
    id: "samewhat",
  },
];

export const studyCosts: responseQuestionType[] = [
  {
    name: "مجانا",
    id: "free",
  },
  {
    name: "برسوم الدراسة",
    id: "with_tuition_free",
  },
  {
    name: "بمكافأة دراسية",
    id: "with_study_stipend",
  },
];

export const providerStatus: responseQuestionType[] = [
  {
    name: "من داخل الأسرة",
    id: "within_family",
  },
  {
    name: "من خارج الأسرة",
    id: "outside_family",
  },
];

export const surveyOptions = [
  { id: 1, name: "الأحدث" },
  { id: 2, name: "الأقدم" },
];
